<template>
  <div>
    <div v-if="tableLoader">
      <Loader />
    </div>
    <div class="card tw-mt-4">
      <div class="d-flex gap-3 tw-justify-between tw-items-center">
        <div class="d-flex gap-3 flex-wrap tw-items-center" id="sos-filters">
          <div class="mr-2">
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Date Range"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDateTableDateRange"
              :max-date="maxDateTableDateRange"
            >
              <!-- @update="getBuyBoxTable" -->
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1 ml-0"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div>

            <multiselect
              @input="handlePlatformSelection"
              v-model="selectedPlatform"
              class="text-capitalize"
              :options="platformList"
              track-by="key"
              label="value"
              :custom-label="updateSelectedLabels"
              :multiple="true"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedPlatform?.length == platformList?.length ? 1 : 100
              "
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedPlatform"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.value.replaceAll("_", " ") }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
            v-show="activeTab == 'product'"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableCategory"
              class="text-capitalize"
              :options="categoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableCategory?.length == categoryList?.length ? 1 : 100
              "
              @input="handleChangeCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
            v-show="activeTab == 'product'"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Sub Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableSubCategory"
              class="text-capitalize"
              :options="subCategoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Sub Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableSubCategory?.length == subCategoryList?.length
                  ? 1
                  : 100
              "
              @input="handleChangeSubCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableSubCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Brand"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedBrand"
              class="text-capitalize"
              :options="brandList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Brand"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="selectedBrand?.length == brandList?.length ? 1 : 100"
              @input="handleBrand"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedBrand"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <!-- <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template> -->
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 220px; max-width: 220px"
            v-show="activeTab == 'Product'"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Price Range"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedPriceRange"
              class="text-capitalize"
              :options="lossPriceRangeList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Price Range"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                lossSelectedPriceRange?.length == lossPriceRangeList?.length
                  ? 1
                  : 100
              "
              @input="handlePriceRange"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedPriceRange"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 180px; max-width: 180px"
            v-show="activeTab == 'product'"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Product"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedProduct"
              limit="1"
              :options="lossProductList"
              :multiple="true"
              :searchable="false"
              placeholder="Select Product"
              :close-on-select="false"
              :allow-empty="true"
              :showLabels="false"
              track-by="key"
              label="value"
              :limit="
                lossSelectedProduct?.length == lossProductList?.length
                  ? 1
                  : 1000
              "
              @input="handleProductIdSelection"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="lossSelectedProduct"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
            <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
            v-if="searchTypeList.length"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Search Term Type"][selectedLanguage.key] }}
            </div> 
            <multiselect
              v-model="selectedSearchType"
              class="text-capitalize"
              :options="searchTypeList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Search Term"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedSearchType?.length == searchTypeList?.length ? 1 : 1000
              "
              @input="changeSearchTermType"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedSearchType"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
           <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
            v-if="searchCategory.length"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Search Term Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedSearchCategory"
              class="text-capitalize"
              :options="searchCategory"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Search Term"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedSearchCategory?.length == searchCategory?.length ? 1 : 1000
              "
              @input="changeSearchTermCategory"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedSearchCategory"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
           <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
            v-if="searchKeyList.length"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Search Range"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedSearchKey"
              class="text-capitalize"
              :options="searchKeyList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Search Term"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedSearchKey?.length == searchKeyList?.length ? 1 : 1000
              "
              @input="changeSearchTermKey"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedSearchKey"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Search Term"][selectedLanguage.key] }}
            </div>
            
            <multiselect
              v-model="selectedSearchTerm"
              class="text-capitalize"
              :options="searchTermList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Search Term"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedSearchTerm?.length == searchTermList?.length ? 1 : 1000
              "
              @input="changeSearchTerm"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedSearchTerm"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedBatchTime"
              class="text-capitalize"
              :options="lossBatchList"
              track-by="batch"
              label="displayname"
              :multiple="false"
              :searchable="false"
              placeholder="Select Batch"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="true"
              :limit="
                selectedBatchTime?.length == lossBatchList?.length ? 1 : 100
              "
            >
              <template #option="{ option }">
                <span class="option__title ml-3 text-capitalize">{{
                  option.displayname.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <button
            class="btn primarycolor py-2 tw-mt-4"
            @click="handleApplyFilters"
          >
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
        </div>
        <div>
          <button class="btn primarycolor py-2 tw-mt-4" @click="handleKeywordCompare"  v-show="activeTab == 'keyword'">
            {{ translatedLang["Compare"][selectedLanguage.key] }}
          </button>
          <!-- <button class="btn primarycolor py-2 tw-mt-4" @click="handleCompare"  v-show="activeTab == 'product'">
            {{ translatedLang["Compare"][selectedLanguage.key] }}
          </button> -->
        </div>
      </div>
    </div>
    <div class="card">
      <div class="d-flex overflow-auto sovReviewedTab">
        <div
          @click="handleTabPanel('keyword')"
          class="mx-3 font-bold tab-label"
          style="cursor: pointer"
          :class="{ active: 'keyword' === activeTab }"
        >
          Keyword
        </div>
        <div
          @click="handleTabPanel('product')"
          class="mx-3 font-bold tab-label"
          style="cursor: pointer"
          :class="{ active: 'product' === activeTab }"
        >
          Product
        </div>
      </div>
      <div class="borderBetweenTab"></div>
      <div v-if="activeTab == 'keyword'">
        <div
          class="summaryContainer"
          v-if="Object.keys(viewKeywordTableData).length"
        >
          <table id="keyword-table" class="tw-w-full">
            <thead class="thead-normal">
              <tr>
                <th
                  v-for="(header, idx) of viewKeywordTableData.headers"
                  :key="header.key + '|' + idx"
                >
                  {{ header.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, idx) of viewKeywordTableData.data"
                :key="data.id + '|' + idx"
                class="tw-border tw-border-[#d4d4d4]"
              >
                <td
                  v-for="header in viewKeywordTableData.headers"
                  :key="header.key + '|' + idx"
                  class=""
                >
                  <div v-if="header.type == 'false'">
                    {{ data[header.key] }}
                  </div>
                  <div
                    v-else-if="header.type == 'delta'"
                    class="tw-flex tw-justify-center"
                  >
                    <upDownCard :data="data[header.key]" class="tw-w-[100px]" />
                  </div>
                  <div v-else-if="header.type == 'bar'" class="tw-w-[100%]">
                    <bar :data="data[header.key]" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <noData :loaderVariable="keywordTableLoader" />
        </div>
      </div>
      <div v-if="activeTab == 'product'">
        <div
          class="summaryContainer"
          v-if="viewProductTableData.headers.length"
        >
          <table id="product-table" class="tw-w-full">
            <thead class="thead-normal">
              <tr>
                <th
                  v-for="(header, idx) of viewProductTableData.headers"
                  :key="header.key + '|' + idx"
                >
                  {{ header.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, idx) of viewProductTableData.data"
                :key="data.id + '|' + idx"
                class="tw-border tw-border-[#d4d4d4]"
              >
                <td
                  v-for="header in viewProductTableData.headers"
                  :key="header.key + '|' + idx"
                  class=""
                >
                  <div v-if="header.type == 'false'">
                    {{ data[header.key] }}
                  </div>
                  <div
                    v-else-if="header.type == 'delta'"
                    class="tw-flex tw-justify-center"
                  >
                    <upDownCard :data="data[header.key]" class="tw-w-[100px]" />
                  </div>
                  <div v-else-if="header.type == 'bar'" class="tw-w-[100%]">
                    <bar :data="data[header.key]" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <noData :loaderVariable="productTableLoader" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";
import upDownCard from "@/views/v3/Components/upDownCard.vue";
import bar from "@/views/v3/Components/bar.vue";
import noData from "../Components/noData.vue";
export default {
  name: "sos",
  components: {
    Multiselect,
    Datepicker,
    Loader,
    Treeselect,
    upDownCard,
    bar,
    noData,
  },
  data() {
    return {
      dateRange: {
        startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      minDateTableDateRange: "",
      maxDateTableDateRange: "",
      selectedPlatform: [],
      platformList: [],
      selectedTableCategory: [],
      categoryList: [],
      categoryTableList: "",
      selectedTableSubCategory: [],
      subCategoryList: [],
      selectedBrand: [],
      brandList: [],
      lossSelectedProduct: [],
      lossProductList: [],
      lossSelectedPIN: [],
      lossPINList: [],
      selectedBatchTime: [],
      lossBatchList: [],
      tableHeader: [],
      tableData: [],
      tableLoader: false,
      uploadedProducts: {},
      allPincodeList: [],
      finalSelectedCategory: [],
      previousSelection: [],
      previousCategorySelection: [],
      previousSubCategorySelection: [],
      previousBrandSelection: [],
      previousProductSelection: [],
      previousPriceRangeSelection: [],
      lossSelectedPriceRange: [],
      lossPriceRangeList: [],
      storeAllDataForStatus: {},
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Share_Of_Search,
      viewKeywordTableData: {},
      viewProductTableData: {
        headers: [],
      },
      keywordTableLoader: false,
      activeTab: "keyword",
      lastUpdated: `${moment().format("YYYY-MM-DD")} 11:00 AM`,
      allSearchTerm: [],
      allSearchTermSecond: [],
      previousSelectedSearchTerm: [],
      searchCategory:[],
      selectedSearchCategory:[],
      previousSearchCategory:[],
      searchKeyList: [],
      selectedSearchKey: [],
      previousSearchKey: [],
      searchTypeList: [],
      selectedSearchType: [],
      previousSearchType: [],
      searchTermList: [],
      selectedSearchTerm: [],
      previousSearchTerm: []
    };
  },
  mounted() {
    this.keywordTableLoader = true;
    this.productTableLoader = true;
    this.getLastUpdatedDates();
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  watch: {
    selectedTableCategory(newVal) {
      let mergedChildren = [];
      newVal.forEach((cat) => {
        if (cat.child && Array.isArray(cat.child)) {
          mergedChildren.push(...cat.child);
        }
      });
      this.subCategoryList = mergedChildren;
      if (this.selectedTableCategory?.length && this.subCategoryList.length) {
        this.subCategoryList.unshift({
          key: "All",
          value: "All",
        });
      }
      const validKeys = new Set(mergedChildren.map((c) => c.key));
      this.selectedTableSubCategory = this.selectedTableSubCategory.filter(
        (subcat) => validKeys.has(subcat.key)
      );
      this.selectedTableSubCategory = this.subCategoryList;
      this.previousSubCategorySelection = [...this.selectedTableSubCategory];
      // this.selectedTableSubCategory = mergedChildren.length
      //   ? [mergedChildren[0]]
      //   : [];
    },
    // dateRange: {
    //   handler() {
    //     this.getAllStatusByApi();
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    // 'segmentDropdown.selectedSegment': function () {
    //         if (Object.keys(this.storeAllDataForStatus).length && this.selectedPlatform.key !== '' && this.segmentDropdown.selectedSegment.key !== '') {
    //             this.$store.dispatch("DemoStore/setUpdatedStatus", this.storeAllDataForStatus[this.selectedPlatform.key][this.segmentDropdown.selectedSegment.key])
    //         } else {
    //             this.$store.dispatch("DemoStore/setUpdatedStatus", '')
    //         }
    //     }
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
      "setSOSCompFilter",
    ]),
    handleCompare() {
      const selectedFilter = {
        selectedPlatform: this.selectedPlatform,
        selectedTableCategory: this.selectedTableCategory,
        selectedTableSubCategory: this.selectedTableSubCategory,
        selectedBrand: this.selectedBrand,
        selectedProduct: this.lossSelectedProduct,
        selectedBatchTime: this.selectedBatchTime,
      };

      this.$store.dispatch("DemoStore/setSOSCompFilter", selectedFilter);
      this.$router.push("/product");
    },
    handleKeywordCompare() {
      this.$router.push("/sos-compare");
    },
    updateSelectedLabels(option) {
      return option.value.replaceAll("_", " ");
    },
    handleTabPanel(data) {
      this.activeTab = data;
      if (data === "keyword") {
        if ($.fn.DataTable.isDataTable("#keyword-table")) {
          $("#keyword-table").DataTable().clear().destroy();
        }
        this.getKeywordTableData();
      } else if (data === "product") {
        if ($.fn.DataTable.isDataTable("#product-table")) {
          $("#product-table").DataTable().clear().destroy();
        }
        this.getProductTableData();
      }
    },
    getLastUpdatedDates() {
      this.tableLoader = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http
        .get(url)
        .then((response) => {
          localStorage.sos = JSON.stringify(response.body.data.sos);
          this.dateRange.endDate = moment(
            response.body.data.sos.end_date
          ).format("YYYY-MM-DD");
          this.dateRange.startDate = moment(
            response.body.data.sos.end_date
          ).subtract(7, "days").format("YYYY-MM-DD");
          this.maxDateTableDateRange = new Date(
            response.body.data.sos.end_date
          );
          // this.handlePlatformSelection()
          this.lastUpdated = `${moment(response.body.data.sos.end_date).format(
            "DD MMM, YYYY"
          )} 
                    ${response.body.data.sos.latest_time ? "at" : ""} 
                    ${
                      response.body.data.sos.latest_time
                        ? response.body.data.sos.latest_time
                        : ""
                    }`;
          this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
          this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
          this.getFiltersData();
        })
        .catch((err) => {
          this.tableLoader = false;
          // this.getBrandDetails();
          console.log("err", err);
        })
        .finally(() => {
          this.tableLoader = false;
        });
    },
    handlePlatformSelection(selected) {
      const otherOptions = this.platformList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedPlatform = [...this.platformList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedPlatform = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedPlatform = [...this.platformList];
        } else {
          this.selectedPlatform = [...selectedWithoutAll];
        }
      }

      this.previousSelection = [...this.selectedPlatform];
      // this.transformSearchTerm(this.selectedPlatform);
      if(this.activeTab='keyword'){
        this.getBrandData();
      } 
      else{
        this.changeTableCategory();
      }
      // this.getBrandData();
    },

    changeTableCategory() {
      if (this.selectedPlatform) {
        this.selectedTableCategory = [];
        this.selectedBrand = [];
        this.lossSelectedProduct = [];
        this.lossSelectedPIN = [];
        const categoryMap = new Map();
        const subCategoryMap = new Map();

        this.categoryList = [];
        this.subCategoryList = [];
        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const categories = this.allCategory[platformKey];

          if (categories?.length) {
            categories.forEach((cat) => {
              if (!categoryMap.has(cat.key)) {
                categoryMap.set(cat.key, cat);
                this.categoryList.push(cat);
              }

              if (cat.child?.length) {
                cat.child.forEach((sub) => {
                  if (!subCategoryMap.has(sub.key)) {
                    subCategoryMap.set(sub.key, sub);
                    this.subCategoryList.push(sub);
                  }
                });
              }
            });
          }
        });
        if (this.selectedPlatform.length) {
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
        }
        const stateMap = new Map();

        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const states = this.allPincodeList[platformKey] || [];

          states.forEach((state) => {
            if (!stateMap.has(state.id)) {
              stateMap.set(state.id, {
                id: state.id,
                label: state.label,
                children: [],
              });
            }

            const stateEntry = stateMap.get(state.id);
            const cityMap = new Map(
              stateEntry.children.map((city) => [city.id, city])
            );

            state.children?.forEach((city) => {
              if (!cityMap.has(city.id)) {
                cityMap.set(city.id, {
                  id: city.id,
                  label: city.label,
                  children: [],
                });
              }

              const cityEntry = cityMap.get(city.id);
              const pinMap = new Map(
                cityEntry.children.map((pin) => [pin.id, pin])
              );

              city.children?.forEach((pin) => {
                if (!pinMap.has(pin.id)) {
                  pinMap.set(pin.id, {
                    id: pin.id,
                    label: pin.label,
                  });
                }
              });

              cityEntry.children = Array.from(pinMap.values());
            });

            stateEntry.children = Array.from(cityMap.values());
          });
        });

        this.lossPINList = Array.from(stateMap.values());

        // this.categoryList = this.allCategory[this.selectedPlatform?.key];
        // this.selectedTableCategory = [this.categoryList[0]];
        // this.subCategoryList = this.categoryList[0].child;
        // this.selectedTableSubCategory = [this.subCategoryList[0]];
        // this.lossPINList = this.allPincodeList[this.selectedPlatform?.key];
        this.handleChangeCategory();
      }
    },

    handleChangeCategory(selected) {
      if (!selected.length) {
        this.selectedTableSubCategory = [];
      }

      const otherOptions = this.categoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableCategory = [...this.categoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableCategory = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableCategory = [...this.categoryList];
        } else {
          this.selectedTableCategory = [...selectedWithoutAll];
        }
      }

      this.previousCategorySelection = [...this.selectedTableCategory];
      this.getBrandData(false);
      this.handleChangeSubCategory();
      // this.$nextTick(() => {
      //   this.getBrandData(false);
      // });
    },
    changeSearchTermType(selected) {
      if (!selected.length) {
        this.selectedSearchType = [];
      }

      const otherOptions = this.searchTypeList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSearchType?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedSearchType = [...this.searchTypeList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedSearchType = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedSearchType = [...this.searchTypeList];
        } else {
          this.selectedSearchType = [...selectedWithoutAll];
        }
      }

      this.previousSearchType = [...this.selectedSearchType];
      this.transformSearchTermCategory();
    },
    changeSearchTermCategory(selected) {
      if (!selected.length) {
        this.selectedSearchCategory = [];
      }

      const otherOptions = this.searchCategory.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSearchCategory?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedSearchCategory = [...this.searchCategory];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedSearchCategory = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedSearchCategory = [...this.searchCategory];
        } else {
          this.selectedSearchCategory = [...selectedWithoutAll];
        }
      }

      this.previousSearchCategory = [...this.selectedSearchCategory];
      this.transformSearchTermKey();
    },
     changeSearchTermKey(selected) {
      if (!selected.length) {
        this.selectedSearchKey = [];
      }

      const otherOptions = this.searchKeyList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSearchKey?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedSearchKey = [...this.searchKeyList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedSearchKey = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedSearchKey = [...this.searchKeyList];
        } else {
          this.selectedSearchKey = [...selectedWithoutAll];
        }
      }

      this.previousSearchKey = [...this.selectedSearchKey];
      this.transformSearchTerm();
    },

    changeSearchTerm(selected) {
      if (!selected.length) {
        this.selectedSearchTerm = [];
      }

      const otherOptions = this.searchTermList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelectedSearchTerm?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedSearchTerm = [...this.searchTermList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedSearchTerm = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedSearchTerm = [...this.searchTermList];
        } else {
          this.selectedSearchTerm = [...selectedWithoutAll];
        }
      }

      this.previousSelectedSearchTerm = [...this.selectedSearchTerm];
    },
    handleChangeSubCategory(selected) {
      if (!selected.length) {
        this.selectedTableSubCategory = [];
      }
      const otherOptions = this.subCategoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSubCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableSubCategory = [...this.subCategoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableSubCategory = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableSubCategory = [...this.subCategoryList];
        } else {
          this.selectedTableSubCategory = [...selectedWithoutAll];
        }
      }

      this.previousSubCategorySelection = [...this.selectedTableSubCategory];

      // this.$nextTick(() => {
      this.getBrandData(false);
      // });
    },

    handleBrand(selected) {
      const otherOptions = this.brandList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousBrandSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedBrand = [...this.brandList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedBrand = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedBrand = [...this.brandList];
        } else {
          this.selectedBrand = [...selectedWithoutAll];
        }
      }

      this.previousBrandSelection = [...this.selectedBrand];
      this.$nextTick(() => {
        this.getProductIdData(false);
      });
    },

    handleProductIdSelection(selected) {
      const otherOptions = this.lossProductList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousProductSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedProduct = [...this.lossProductList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedProduct = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedProduct = [...this.lossProductList];
        } else {
          this.lossSelectedProduct = [...selectedWithoutAll];
        }
      }

      this.previousProductSelection = [...this.lossSelectedProduct];
    },
    handlePriceRange(selected) {
      const otherOptions = this.lossPriceRangeList.filter(
        (p) => p.key !== "all"
      );

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "all");
      const wasAllPreviouslySelected = this.previousPriceRangeSelection?.some(
        (opt) => opt.key === "all"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [...this.lossPriceRangeList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "all");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedPriceRange = [...this.lossPriceRangeList];
        } else {
          this.lossSelectedPriceRange = [...selectedWithoutAll];
        }
      }

      this.previousPriceRangeSelection = [...this.lossSelectedPriceRange];
      this.getProductIdData();
    },
    handleApplyFilters() {
      if ($.fn.DataTable.isDataTable("#disparity-table")) {
        $("#disparity-table").DataTable().clear().destroy();
      }
      if (this.activeTab == "keyword") {
        this.getKeywordTableData();
      } else if (this.activeTab == "product") {
        this.getProductTableData();
      }
    },
    getFiltersData(isMounted) {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          this.platformList = response.data.data.platform;
          if (this.platformList.length) {
            this.platformList.unshift({ key: "All", value: "All" });
          }
          this.lossPriceRangeList = response.data.data.price_range;
          // this.lossPriceRangeList = this.lossPriceRangeList.filter(
          //   (price) => price.key != "all"
          // );
          this.allSearchTermSecond= response.data.data.search;
          this.selectedPlatform = [...this.platformList];
          this.previousSelection = [...this.selectedPlatform];
          if (Object.keys(response.data.data.batch).length) {
            this.lossBatchList = response.data.data.batch["share of search"];
            this.selectedBatchTime = this.lossBatchList[0];
            this.batchList = response.data.data.batch["share of search"];
          }
          this.allCategory = response.data.data.category;
          this.categoryList = [];
          this.subCategoryList = [];
          const categoryMap = new Map();

          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
          this.selectedTableCategory = this.categoryList;
          this.previousCategorySelection = [...this.selectedTableCategory];
          this.platformList.forEach((platform) => {
            const platformKey = platform.key;
            const categories = this.allCategory[platformKey];

            if (categories?.length) {
              categories.forEach((cat) => {
                if (!categoryMap.has(cat.key)) {
                  categoryMap.set(cat.key, cat);
                  this.categoryList.push(cat);
                }
              });
            }
          });
          // this.transformSearchTerm(this.platformList);
          const stateMap = new Map();

          this.selectedPlatform.forEach((platform) => {
            const platformKey = platform.key;
            const states = response.data.data.pincode[platformKey] || [];

            states.forEach((state) => {
              if (!stateMap.has(state.id)) {
                stateMap.set(state.id, {
                  id: state.id,
                  label: state.label,
                  children: [],
                });
              }

              const stateEntry = stateMap.get(state.id);
              const cityMap = new Map(
                stateEntry.children.map((city) => [city.id, city])
              );

              state.children?.forEach((city) => {
                if (!cityMap.has(city.id)) {
                  cityMap.set(city.id, {
                    id: city.id,
                    label: city.label,
                    children: [],
                  });
                }

                const cityEntry = cityMap.get(city.id);
                const pinMap = new Map(
                  cityEntry.children.map((pin) => [pin.id, pin])
                );

                city.children?.forEach((pin) => {
                  if (!pinMap.has(pin.id)) {
                    pinMap.set(pin.id, {
                      id: pin.id,
                      label: pin.label,
                    });
                  }
                });

                cityEntry.children = Array.from(pinMap.values());
              });

              stateEntry.children = Array.from(cityMap.values());
            });
          });

          this.lossPINList = Array.from(stateMap.values());

          this.allPincodeList = response.data.data.pincode;

          this.getBrandData(isMounted).then(() => {
            this.getKeywordTableData();
            // this.getProductTableData();
          });

          //   this.lossSelectedPIN = this.lossPINList[0];
          //   this.setPlatformWiseDateTable(true);
          // this.getAllStatusByApi('forBuyBoxTable');
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    // transformSearchTerm(platformName) {
    //   const searchTermMap = new Map();
    //   this.searchTermList = [];

    //   if (platformName.length) {
    //     this.searchTermList.unshift({
    //       key: "All",
    //       value: "All",
    //     });
    //   }

    //   platformName.forEach((platform) => {
    //     const platformKey = platform.key;
    //     const searchTerm = this.allSearchTerm[platformKey];

    //     if (searchTerm?.length) {
    //       searchTerm.forEach((cat) => {
    //         if (!searchTermMap.has(cat.key)) {
    //           searchTermMap.set(cat.key, cat);
    //           this.searchTermList.push(cat);
    //         }
    //       });
    //     }
    //   });
    //   this.selectedSearchTerm = [...this.searchTermList];
    //   this.previousSelectedSearchTerm = [...this.selectedSearchTerm];
    // },

    async getBrandData(isMounted) {
      const url = "/api/v2/brand/data";

      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        pincode: this.lossSelectedPIN?.length ? this.lossSelectedPIN : [],
      };
      await this.$http
        .post(url, payload)
        .then((res) => {
          this.brandList = res.data.data;
          if (this.brandList.length) {
            this.brandList.unshift({ key: "All", value: "All" });
          }
          this.selectedBrand = [...this.brandList];
          this.previousBrandSelection = [...this.selectedBrand];
          this.getLevelData();
          return this.getProductIdData(isMounted);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getProductIdData(isMounted) {
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      const url = "/api/v2/product/data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        category: this.finalSelectedCategory,
        brand: this.selectedBrand?.length
          ? this.selectedBrand
              ?.filter((p) => p.key !== "All")
              ?.map((brand) => brand.key)
          : [],
      };
      await this.$http
        .post(url, payload)
        .then((res) => {
          this.lossProductList = res.data.data;
          if (this.lossProductList.length) {
            this.lossProductList.unshift({ key: "All", value: "All" });
          }
          this.lossSelectedProduct = [...this.lossProductList];
          this.previousProductSelection = [...this.lossSelectedProduct];
          //   this.lossSelectedProduct = [this.lossProductList[0]];
          // if (isMounted) this.getKeywordTableData();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getLevelData(isMounted) {
      const url = "/api/v1/india_clients/new_sos";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        // end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        website: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
      };
      this.$http
        .post(url, payload)
        .then((res) => {
            this.allSearchTerm = res.data.data;
            if(this.allSearchTerm.length) {
              this.searchTypeList = res.data.data;
              if (this.searchTypeList.length) {
                this.searchTypeList.unshift({ key: "All", value: "All" });
              }
              this.selectedSearchType = [...this.searchTypeList];
              this.previousSearchType = [...this.selectedSearchType];

              this.transformSearchTermCategory();
            }
            else{
              this.transformSearchTermSecond(this.platformList);

            }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    transformSearchTermSecond(platformName) {
      const searchTermMap = new Map();
      this.searchTermList = [];

      if (platformName.length) {
        this.searchTermList.unshift({
          key: "All",
          value: "All",
        });
      }

      platformName.forEach((platform) => {
        const platformKey = platform.key;
        const searchTerm = this.allSearchTermSecond[platformKey];

        if (searchTerm?.length) {
          searchTerm.forEach((cat) => {
            if (!searchTermMap.has(cat.key)) {
              searchTermMap.set(cat.key, cat);
              this.searchTermList.push(cat);
            }
          });
        }
      });
      this.selectedSearchTerm = [...this.searchTermList];
      this.previousSelectedSearchTerm = [...this.selectedSearchTerm];
    },
    transformSearchTermCategory(){
      this.searchCategory = [];
      this.selectedSearchType.forEach((type) => {
        if(type.key !== "All"){
         this.searchCategory.push(type?.child)
        }
      });
      this.searchCategory = this.searchCategory.flat();
      // console.log("searchCategory before",this.searchCategory)
      if (this.searchCategory.length) {
        this.searchCategory.unshift({ key: "All", value: "All" });
      }
      // console.log("searchCategory",this.searchCategory)
      this.selectedSearchCategory = [...this.searchCategory];
      this.previousSearchCategory = [...this.selectedSearchCategory];
      this.transformSearchTermKey();
    },

    transformSearchTermKey(){
        this.searchKeyList = [];
        // collect all children except when type.key === "All"
        this.selectedSearchCategory.forEach((type) => {
          if (type.key !== "All") {
            this.searchKeyList.push(...(type.child || []));
          }
        });
        const tempSearchKey = this.searchKeyList;
        // remove duplicates by key
        const uniqueMap = new Map();
        this.searchKeyList.forEach((item) => {
          if (!uniqueMap.has(item.key)) {
            uniqueMap.set(item.key, item);
          }
        });
        this.searchKeyList = Array.from(uniqueMap.values());
       let temp = {};
       tempSearchKey.forEach((item) => {
          const key = item.key;
          const children = item.child || [];
          if (!temp.hasOwnProperty(key)) {
            temp[key] = [];
          } else {
          }
          temp[key].push(...children);
        });
        this.searchKeyList = this.searchKeyList.map((key) => ({
            key: key.key,
            value: key.value,
            child: [...temp[key.key]],
        }));
        if (this.searchKeyList.length) {
          this.searchKeyList.unshift({ key: "All", value: "All" });
        }       
        this.selectedSearchKey = [...this.searchKeyList];
        this.previousSearchKey = [...this.selectedSearchKey];
        this.transformSearchTerm();

    },

    transformSearchTerm(){
      this.searchTermList = [];
      this.selectedSearchKey.forEach((type) => {
        if(type.key !== "All"){
            this.searchTermList.push(...(type.child || []));
        }
      });
      this.searchTermList = this.searchTermList.flat();
        // remove duplicates by key
       const uniqueMap = new Map();
      this.searchTermList.forEach((item) => {
          if (!uniqueMap.has(item.key)) {
            uniqueMap.set(item.key, item);
        }
      });
      // this.searchTermList = Array.from(uniqueMap.values());

      if (this.searchTermList.length) {
        this.searchTermList.unshift({ key: "All", value: "All" });
      }
      this.selectedSearchTerm = [...this.searchTermList];
      this.previousSelectedSearchTerm = [...this.selectedSearchTerm];
    },

    getKeywordTableData() {
      // $("#disparity-table").DataTable().destroy();
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      this.viewKeywordTableData = {};
      this.keywordTableLoader = true;
      const url = "/api/v2/india_clients/sos_distribution";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        feature_id: this.featureId,
        batch: [this.selectedBatchTime?.batch],
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        search_term: this.selectedSearchTerm.length
          ? this.selectedSearchTerm
              .filter((val) => val.key != "All")
              .map((searchTerm) => searchTerm.key)
          : [],
        brand: this.selectedBrand.length
          ? this.selectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
//         "item_category":["2.1 home theater"],# string to list level-4 (Search Term)
// "type":["Audio"], # new key level-1
// "search":["2MM-5MM"], # new key level-3
// "category":["TWS/Headphones"] # new key level-2
        category: this.selectedSearchCategory.length
          ? this.selectedSearchCategory
              .filter((val) => val.key != "All")
              .map((searchCategory) => searchCategory.key)
          : [],
        type: this.selectedSearchType.length
          ? this.selectedSearchType
              .filter((val) => val.key != "All")
              .map((searchType) => searchType.key)
          : [],
        search: this.selectedSearchKey.length
          ? this.selectedSearchKey
              .filter((val) => val.key != "All")
              .map((searchKey) => searchKey.key)
          : [],
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.tableLoader = false;
          this.tableHeader = res.data.data.headers;
          this.viewKeywordTableData = res.data.data;
          this.keywordTableLoader = false;
          //   this.tableData = res.data.data.data;
          this.$nextTick(() => {
            this.processTable("#keyword-table", 1);
          });
          this.keywordTableLoader = false;
        })
        .catch((err) => {
          console.error(err);
          this.tableLoader = false;
          this.keywordTableLoader = false;
        });
    },

    getProductTableData() {
      // $("#disparity-table").DataTable().destroy();
      this.productTableLoader = true;
      this.viewProductTableData = {
        headers: [],
      };
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      const url = "/api/v2/india_clients/sos_distribution_product";
      let payload = {
        platforms: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category_ids: this.finalSelectedCategory,
        brand_names: this.selectedBrand?.length
          ? this.selectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        pincodes: this.lossSelectedPIN,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        batch: this.selectedBatchTime?.batch,
      };
      payload = {};
      payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        feature_id: this.featureId,
        batch: [this.selectedBatchTime?.batch],
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        brands: this.selectedBrand?.length
          ? this.selectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        product: this.lossSelectedProduct?.length
          ? this.lossSelectedProduct
              ?.filter((product) => product.key !== "All")
              .map((product) => product.key)
          : [],
        page: [1, 2, 3, 4],
         item_category: this.selectedSearchTerm.length
          ? this.selectedSearchTerm
              .filter((val) => val.key != "All")
              .map((searchTerm) => searchTerm.key)
          : [],
        category: this.selectedSearchCategory.length
          ? this.selectedSearchCategory
              .filter((val) => val.key != "All")
              .map((searchCategory) => searchCategory.key)
          : [],
        type: this.selectedSearchType.length
          ? this.selectedSearchType
              .filter((val) => val.key != "All")
              .map((searchType) => searchType.key)
          : [],
        search: this.selectedSearchKey.length
          ? this.selectedSearchKey
              .filter((val) => val.key != "All")
              .map((searchKey) => searchKey.key)
          : [],
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.tableLoader = false;
          this.tableHeader = res.data.data.headers;
          this.viewProductTableData = res.data.data;
          //   this.tableData = res.data.data.data;
          this.$nextTick(() => {
            this.processTable("#product-table", 1);
          });
          this.productTableLoader = false;
        })
        .catch((err) => {
          console.error(err);
          this.tableLoader = false;
          this.productTableLoader = false;
        });
    },

    processTable(id, sortCol = 0) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        sorting: [[sortCol, "desc"]],
        // scrollY: scrollVertical || false,
        initComplete: function (settings, json) {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });

      $(id + "_filter > label").append(`
          <div class='search_icon'>
              <img src='/Icons_SVG/Search.svg' width='20' />
          </div>
          `);
    },

    uploadProductTemplate(e) {
      this.uploadedProducts = {
        ...this.uploadedProducts,
        file: e.target.files[0],
      };
      const url = "/api/india_clients/download/product";
      const payload = new FormData();
      payload.append("file", this.uploadedProducts.file);

      this.$http
        .post(url, payload)
        .then((res) => {
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.borderBetweenTab {
  border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
  margin-bottom: 15px !important;
}

.tab-label {
  cursor: pointer;
  padding-bottom: 5px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
}

.tab-label.active {
  color: rgba(6, 85, 89, 1);
  border-bottom: 1px solid rgba(6, 85, 89, 1);
  font-weight: 600 !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 5px 0px !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}
</style>
<style>
#sos-filters .multiselect__strong {
  display: none !important;
}
</style>
